import { render } from "./PublicRegisterView.vue?vue&type=template&id=57811798&scoped=true&ts=true"
import script from "./PublicRegisterView.vue?vue&type=script&lang=ts"
export * from "./PublicRegisterView.vue?vue&type=script&lang=ts"

import "./PublicRegisterView.vue?vue&type=style&index=0&id=57811798&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57811798"]])

export default __exports__